<footer class="footer">
    <div class="container">
        <span class="text-muted"></span>
    </div>

</footer>